// src/pages/ProjectsPage.js
import React, { useEffect, useState } from "react";
import FIT from "../Images/Focus Website.png"
import institute from "../Images/Focus Institute.PNG"
import portal from "../Images/Focus Portal.PNG"
import In360 from "../Images/Focus 360.PNG"
import resumetool from "../Images/resumetool.png"
import passwordtool from "../Images/passwordtool.png"
import qrtool from "../Images/qrtool.jpeg"
import thicknesstool from "../Images/thicknesstool.jpg"
import defecttool from "../Images/defecttool.png"

import { ArrowRight, Box, ChevronDown, ExternalLink, Rocket } from "lucide-react";
import { Link } from "react-router-dom";

const projects = [
  {
    year: "2018",
    title: "Username and Password Generator",
    description:
      "Auto-generate strong usernames and passwords with one click. Fully customizable UI with HTML, CSS, and JavaScript. Users can select password length, include special characters, numbers, and uppercase letters. Ideal for improving security practices, this tool also allows saving and copying generated credentials easily.",
    tags: ["JavaScript", "HTML", "CSS", "Security", "Mini Project"],
    images: [
  "https://images.unsplash.com/photo-1762330472502-83efbe1d4478?q=80&w=1470&auto=format&fit=crop"
],

    category: "Personal / Mini Tools",
  },
  {
    year: "2019",
    title: "Theft Detection System",
    description:
      "IoT-based theft detection system that monitors unauthorized movement using sensors. It sends real-time email alerts, logs events with timestamps, and displays interactive charts for easy monitoring.",
    tags: ["IoT", "Sensors", "JavaScript", "Email Automation"],
    images: ["https://images.unsplash.com/photo-1520697830682-bbb6e85e2b0b?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"],
    category: "IoT Projects",
  },
  {
    year: "2020",
    title: "Home Automation (IoT)",
    description:
      "IoT-based home automation system that allows users to control home appliances via mobile app or PC. The system integrates with Google Assistant for seamless voice commands, providing a smart and convenient home experience.",
    tags: ["IoT", "Blynk", "Google Assistant", "Automation", "Smart Home"],
    images: ["https://images.unsplash.com/photo-1712599609774-172848255a9f?q=80&w=1373&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"],
    category: "IoT Projects",
  },
  {
    year: "2021",
    title: "Augmented Reality App (Education)",
    description:
      "AR app designed to enhance learning by spawning interactive 3D models. Users can visualize animals, vehicles, and human anatomy in real-world environments.",
    tags: ["AR", "3D", "Education", "Unity", "Mobile App"],
    images: ["https://images.unsplash.com/photo-1739638726828-d0f3df0dcde1?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"],
    category: "AR / Education",
  },
  {
    year: "2022",
    title: "Godrej Welding Project",
    description:
      "Industrial automation project optimizing welding processes with real-time data logging, reporting, and automation features.",
    tags: ["Industrial Automation", "Welding", "IoT", "React", "Node.js", "AWS"],
    images: ["https://images.unsplash.com/photo-1720036236697-018370867320?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"],
    category: "Industrial Projects",
  },
  {
    year: "2023",
    title: "Focus Inspection Technology",
    description:
      "Corporate website for an industrial inspection and calibration company. Features interactive service sections and case studies.",
    tags: ["Web App", "Inspection", "Calibration", "Client Portal", "React"],
    images: [FIT],
    url: "https://focusinspectiontechnology.com/",
    category: "Corporate Websites",
  },
  {
    year: "2023",
    title: "Resume Creator Tool",
    description:
      "Build an ATS-friendly resume instantly. Add your skills, experience, and achievements to download it quickly.",
    tags: ["React", "JavaScript", "TailwindCSS", "Mini Tool"],
    category: "IT Tools",
    url: "/createresume",
    images: [resumetool],
  },
  {
    year: "2023",
    title: "Password Generator Tool",
    description:
      "Generate strong and secure passwords with one click. Customize length and special characters.",
    tags: ["React", "JavaScript", "TailwindCSS", "Mini Tool"],
    category: "IT Tools",
    url: "/passwordgenerator",
    images: [passwordtool],
  },
  {
    year: "2023",
    title: "QR Code Generator Tool",
    description:
      "Create QR codes for links, text, contact info, or Wi-Fi credentials. Download instantly.",
    tags: ["React", "JavaScript", "TailwindCSS", "Mini Tool"],
    category: "IT Tools",
    url: "/qrgenerator",
    images: [qrtool],
  },
  {
    year: "2023",
    title: "UT Thickness Calculator",
    description:
      "Convert ultrasonic time readings into material thickness quickly for industrial inspection.",
    tags: ["React", "JavaScript", "Industrial Tool"],
    category: "NDT Tools",
    url: "/thicknesscalculator",
    images: [thicknesstool],
  },
  {
    year: "2023",
    title: "Weld Defect Checker",
    description:
      "Identify and categorize weld defects using visual guidelines and reference standards.",
    tags: ["React", "JavaScript", "Industrial Tool"],
    category: "NDT Tools",
    url: "/weldchecker",
    images: [defecttool],
  },
  {
    year: "2023",
    title: "Hardness Converter",
    description:
      "Convert between Brinell, Vickers, Rockwell hardness scales for precise material testing.",
    tags: ["React", "JavaScript", "Industrial Tool"],
    category: "NDT Tools",
    images: ["https://images.unsplash.com/photo-1681108212545-04cabe9cf771?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"],
    url: "/hardness-converter",
  },
  {
    year: "2024",
    title: "Focus Portal Client and Admin",
    description:
      "Centralized platform for managing inspection workflows, assets, and reporting dashboards for clients and admins.",
    tags: ["SaaS", "Dashboard", "React", "Firebase", "Analytics"],
    images: [portal],
    url: "https://focusinspection-portal.web.app/",
    category: "SaaS & Platforms",
  },
  {
    year: "2025",
    title: "Focus Group Corporate Website",
    description:
      "Corporate website for Focus Group showcasing mission, achievements, and services with a modern, responsive design.",
    tags: ["React", "Firebase", "TailwindCSS", "Web Design"],
    url: "https://focusgroup.com",
    images: ["https://images.unsplash.com/photo-1513257805917-a0da1146eb15?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"],
    category: "Corporate Websites",
  },
  {
    year: "2025",
    title: "Focus Institute of NDT Technology",
    description:
      "Training institute website designed to showcase certifications, courses, and NDT educational content.",
    tags: ["Education", "NDT", "React", "Firebase", "TailwindCSS"],
    images: [institute],
    url: "https://focus-institute.web.app/",
    category: "Corporate Websites",
  },
  {
    year: "2025",
    title: "FocusIn360 SaaS",
    description:
      "Cloud-based SaaS platform for managing industrial inspection and calibration workflows with asset management, dashboards, and analytics.",
    tags: ["SaaS", "Cloud", "React", "Firebase", "Analytics"],
    images: [In360],
    url: "https://focusin360.com",
    category: "SaaS & Platforms",
  },
  {
    year: "2026+",
    title: "Upcoming Project",
    description: "Exciting projects will grow here soon!",
    tags: ["Innovation", "Future Projects"],
    upcoming: true,
    images: ["https://images.unsplash.com/photo-1692699203597-b5a4464f3f9c?q=80&w=1470&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"],
    category: "Upcoming",
  },
];

export default function Projects() {
  const [activeTab, setActiveTab] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [quickListOpen, setQuickListOpen] = useState(false);
  const [quickSearch, setQuickSearch] = useState("");

  useEffect(() => {
    document.title = "Omkar More – Projects Portfolio | IT & NDT Projects";
    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        "content",
        "Browse Omkar More's project portfolio including SaaS platforms, IoT systems, AR apps, corporate websites, and industrial automation projects."
      );
    }
  }, []);

  // Filter logic
  const filteredProjects = projects.filter((p) => {
    if (activeTab === "all") return true;
    if (activeTab === "live") return !!p.url && !p.upcoming;
    if (activeTab === "other") return !p.url && !p.upcoming && p.category !== "Upcoming";
    if (activeTab === "upcoming") return p.upcoming;
    return true;
  });

  // Group by category
  const categories = filteredProjects.reduce((acc, project) => {
    const category = project.category || "Others";
    if (!acc[category]) acc[category] = [];
    acc[category].push(project);
    return acc;
  }, {});

  return (
<div className="bg-slate-50 min-h-screen pb-24">
      {/* 1. HERO HEADER (Matches your theme) */}
<section className="bg-white border-b border-slate-200 pt-24 md:pt-32 pb-12 md:pb-16 px-4 sm:px-6">
  <div className="max-w-7xl mx-auto">
    <div className="flex flex-col lg:flex-row justify-between lg:items-end gap-8 md:gap-12">
      
      {/* TEXT CONTENT */}
      <div className="max-w-2xl w-full">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-8 md:w-10 h-[1px] bg-cyan-600" />
          <span className="font-mono text-[10px] md:text-xs tracking-[0.3em] md:tracking-[0.4em] uppercase font-black text-slate-400">
            Project Archive
          </span>
        </div>
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-black text-slate-950 tracking-tighter leading-[1.1]">
          Selected <span className="text-cyan-600 font-light">&</span>
          <br className="hidden sm:block" /> 
          <span className="sm:mt-2 block">Deployments</span>
        </h1>
      </div>

      {/* ACTION CONTAINER */}
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:gap-4 w-full lg:w-auto">
        
        {/* ENGINEERING TOOLS BUTTON */}
        <Link
          to="/tools"
          className="flex items-center justify-center gap-3 border-2 border-slate-200 text-slate-950 px-5 md:px-6 py-3.5 md:py-4 rounded-xl font-black text-[10px] uppercase tracking-widest hover:border-cyan-600 hover:text-cyan-600 transition-all active:scale-95 group bg-white shadow-sm"
        >
          <span className="whitespace-nowrap">Engineering Tools</span>
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </Link>

        {/* QUICK LINK DROPDOWN */}
        <div className="relative w-full sm:w-auto">
          <button
            onClick={() => setQuickListOpen(!quickListOpen)}
            className="w-full sm:w-auto flex items-center justify-center gap-4 bg-slate-950 text-white px-5 md:px-6 py-3.5 md:py-4 rounded-xl font-black text-[10px] uppercase tracking-widest hover:bg-cyan-600 transition-all active:scale-95 shadow-xl shadow-slate-200"
          >
            <span className="whitespace-nowrap">Index Search</span>
            <ChevronDown size={14} className={`transition-transform duration-300 ${quickListOpen ? "rotate-180" : ""}`} />
          </button>

          {/* Dropdown Menu - Mobile Friendly Positioning */}
          {quickListOpen && (
            <div className="absolute left-0 sm:right-0 sm:left-auto mt-4 w-full sm:w-80 bg-white border border-slate-200 rounded-2xl shadow-2xl z-50 overflow-hidden animate-in fade-in zoom-in duration-200">
              <div className="p-4 border-b border-slate-100 bg-slate-50">
                <input
                  type="text"
                  placeholder="SEARCH PROJECTS..."
                  autoFocus
                  value={quickSearch}
                  onChange={(e) => setQuickSearch(e.target.value)}
                  className="w-full bg-transparent text-[10px] font-bold uppercase tracking-widest focus:outline-none placeholder:text-slate-400"
                />
              </div>
              <div className="max-h-60 overflow-y-auto overscroll-contain custom-scrollbar">
                {projects
                  .filter(p => p.title.toLowerCase().includes(quickSearch.toLowerCase()))
                  .map((proj, i) => (
                    <a 
                      key={i} 
                      href={proj.url} 
                      className="block px-6 py-4 text-[11px] font-bold text-slate-600 hover:text-cyan-600 hover:bg-slate-50 transition-colors border-b border-slate-50 last:border-0 uppercase tracking-tighter"
                    >
                      {proj.title}
                    </a>
                  ))
                }
                {projects.filter(p => p.title.toLowerCase().includes(quickSearch.toLowerCase())).length === 0 && (
                  <div className="px-6 py-8 text-[10px] text-center font-bold text-slate-400 uppercase tracking-widest">
                    No matching records found
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
</section>

      <div className="max-w-7xl mx-auto px-6 mt-12">
        {/* 2. NAVIGATION TABS */}
        <div className="flex flex-wrap gap-2 mb-16 border-b border-slate-200 pb-8">
          {["all", "live", "other", "upcoming"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-6 py-3 rounded-lg text-[10px] font-black uppercase tracking-[0.2em] transition-all ${
                activeTab === tab 
                ? "bg-cyan-600 text-white shadow-lg shadow-cyan-100" 
                : "bg-white text-slate-400 border border-slate-200 hover:border-cyan-600 hover:text-cyan-600"
              }`}
            >
              {tab} <span className="ml-2 opacity-50">/ {projects.filter(p => tab === 'all' || (tab === 'live' && p.url && !p.upcoming) || (tab === 'other' && !p.url && !p.upcoming) || (tab === 'upcoming' && p.upcoming)).length}</span>
            </button>
          ))}
        </div>

        {/* 3. PROJECT GRID BY CATEGORY */}
        {Object.keys(categories).map((category, idx) => (
          <div key={idx} className="mb-24">
            <div className="flex items-center gap-4 mb-10">
              <h2 className="text-2xl font-black uppercase tracking-tight text-slate-900">{category}</h2>
              <div className="h-[1px] flex-1 bg-slate-200" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {categories[category].map((project, i) => (
                <div key={i} className="group bg-white border border-slate-200 rounded-3xl overflow-hidden hover:shadow-2xl hover:shadow-slate-200 transition-all duration-500 flex flex-col">
                  {/* Image/Placeholder */}
                  <div className="relative aspect-video bg-slate-100 overflow-hidden">
                    {project.images ? (
                      <img src={project.images[0]} alt={project.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-slate-200">
                        <Box size={40} />
                      </div>
                    )}
                    <div className="absolute top-4 left-4">
                      <span className="bg-slate-950/90 backdrop-blur text-white text-[9px] font-black px-3 py-1.5 rounded-md uppercase tracking-widest">
                        {project.year}
                      </span>
                    </div>
                  </div>

                  {/* Details */}
                  <div className="p-8 flex-1 flex flex-col">
                    <h3 className="text-xl font-black text-slate-950 uppercase mb-3 leading-none group-hover:text-cyan-600 transition-colors">
                      {project.title}
                    </h3>
                    <p className="text-slate-500 text-sm leading-relaxed mb-6 flex-1">
                      {project.description}
                    </p>

                    {/* Tags Styled like IT/NDT tags */}
                    <div className="flex flex-wrap gap-2 mb-8">
                      {project.tags.map((tag, j) => (
                        <span key={j} className="px-3 py-1.5 bg-slate-50 text-slate-500 border border-slate-100 rounded text-[9px] font-black uppercase tracking-tighter">
                          {tag}
                        </span>
                      ))}
                    </div>

                    {/* Footer Actions */}
                    <div className="pt-6 border-t border-slate-50 mt-auto">
                      {project.upcoming ? (
                        <div className="flex items-center gap-2 text-orange-500 font-mono text-[10px] font-black uppercase tracking-widest">
                          <Rocket size={14} /> Pipeline / Upcoming
                        </div>
                      ) : (
                        <a 
                          href={project.url} 
                          target="_blank" 
                          className="inline-flex items-center gap-2 text-cyan-600 font-mono text-[10px] font-black uppercase tracking-[0.2em] group/link"
                        >
                          Launch Project <ArrowRight size={14} className="group-hover/link:translate-x-1 transition-transform" />
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}